import { render } from "./restructureWizard.vue?vue&type=template&id=22e909d6"
import script from "./restructureWizard.vue?vue&type=script&lang=js"
export * from "./restructureWizard.vue?vue&type=script&lang=js"

import "./restructureWizard.vue?vue&type=style&index=0&id=22e909d6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__